module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/coj_d-2-76367dde0a2290c0f5490526c45c2d87.jpg";